import { LanguageLevelEnum, UsersLanguagesInterface } from '../../..';

export class UserToLanguageDto implements UsersLanguagesInterface {
  key: string;
  languageLevel: LanguageLevelEnum;
}
